import * as fromDatatype from '../datatype-library/index';

export interface bl_bi_report_query_run_output_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  query_run_hdr_guid: fromDatatype.GuidDataFieldInterface;
  query_status: fromDatatype.VarcharDatatypeInterface;
  data_json: fromDatatype.JsonDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  output_type: fromDatatype.VarcharDatatypeInterface;
  output_file_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_bi_report_query_run_output_hdr_RowClass
  implements bl_bi_report_query_run_output_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  query_run_hdr_guid: fromDatatype.GuidDataFieldInterface;
  query_status: fromDatatype.VarcharDatatypeInterface;
  data_json: fromDatatype.JsonDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  output_type: fromDatatype.VarcharDatatypeInterface;
  output_file_hdr_guid: fromDatatype.GuidDataFieldInterface;
}
